const PRODUCTION_API_BASE_URL = "https://fleetx-backend-u4k6.onrender.com/api";
const DEVELOPMENT_API_BASE_URL = "http://localhost:5000/api";

const configuredApiBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "").trim();

if (!configuredApiBaseUrl && process.env.NODE_ENV === "production") {
  console.error(
    "REACT_APP_API_BASE_URL is not configured. Set it to the production backend API URL."
  );
}

export const API_BASE_URL = (
  configuredApiBaseUrl ||
  (process.env.NODE_ENV !== "production"
    ? DEVELOPMENT_API_BASE_URL
    : PRODUCTION_API_BASE_URL)
).replace(/\/+$/, "");

export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "").replace(/\/$/, "");

export const CUSTOMER_WEB_URL = String(
  process.env.REACT_APP_CUSTOMER_WEB_URL ||
    (process.env.NODE_ENV !== "production"
      ? "http://localhost:5173"
      : "https://fleetxph.com")
).replace(/\/+$/, "");
